import Api from "@/services/api.js";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  props: ["cnpj_value", "id_empresa", "intIndexMensagem", "preencheCnpj"],
  components: {
    BotaoPadrao,
    Header,
    LoadingPadraoContainer
  },
  data() {
    return {
      desativado: false,
      blLoading: false,
      blErro: false,
      strErro: "",
      arMensagem: [
        "Tempo excedido de resposta do servidor da Receita Federal. <br> Se a imagem não aparecer, tente novamente mais tarde ou selecione um CNAE manualmente.",
        "Tempo excedido de resposta do servidor da Receita Federal. <br> Se a imagem não aparecer, tente novamente mais tarde ou adicione as CNAEs manualmente."
      ]
    };
  },

  methods: {
    verificaCNPJ(id, origem, cenario, blMantemErro = false, dadosEcoHub = null ) {
      this.cenario = cenario;
      this.id = id;
      this.origem = origem;

      this.strErro = '';
      if (!blMantemErro) this.blErro = false;

      if (this.desativado) return;

      if (dadosEcoHub) {
        const responseFormatted = {
          dados: {
            rem: [{
              value: dadosEcoHub.cnaePrincipalCodigo,
              header: false
            }]
          }
        };
        this.processarResposta(responseFormatted);
        return;
      }

      this.consultarCNPJEcoHub();
    },
    consultarCNPJEcoHub() {

      const cnpjValue = this.$parent.cnpjModalCaptcha || this.cnpj_value ||
                       (this.$parent.dadosForm && this.$parent.dadosForm.cnpjRemetente);

      if (!cnpjValue) {
        this.blErro = true;
        this.strErro = "CNPJ não informado";
        this.blLoading = false;
        return;
      }

      this.blLoading = true;
      this.blErro = false;

      fetch('https://ecohub-vendas.econeteditora.com.br/api/leads/rte', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tipoConsulta: 'cnpj', dados: { cnpj: cnpjValue } })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          const responseFormatted = {
            dados: {
              rem: [{
                value: data.data.cnaePrincipalCodigo,
                header: false
              }]
            }
          };
          this.processarResposta(responseFormatted);
        } else {
          this.blErro = true;
          this.strErro = "CNPJ não encontrado";
          this.blLoading = false;
        }
      })
      .catch(error => {
        console.error('Erro ao consultar CNPJ:', error);
        this.blErro = true;
        this.strErro = "Erro ao consultar CNPJ";
        this.blLoading = false;
      });
    },
    processarResposta(response) {
      if (response.dados && response.dados.rem && response.dados.rem.length > 0) {
        // Usa dados do EcoHub
        const cnpjValue = this.$parent.cnpjModalCaptcha || this.cnpj_value;
        const primeiroRem = response.dados.rem.find(item => !item.header);
        if (primeiroRem) {
          if(this.cenario){
            this.cnaeValue = primeiroRem.value;
            // Chama o método preencheCnpj do componente pai
            this.$parent.preencheCnpj(this.id, this.origem, cnpjValue, this.cnaeValue);
          } else {
            // Para não sobrescrever dados da empresa, apenas fecha o modal
            // O componente pai deve lidar com a atualização das CNAEs
            this.$parent.blAtualizarReceita = false;
          }
        } else {
          this.blErro = true;
          this.strErro = "Nenhum CNAE encontrado";
        }
      } else {
        this.blErro = true;
        this.strErro = response.mensagem || "CNPJ não encontrado";
      }
    },

    closeModal: function() {
      this.$refs.verificacaoCnae.hide();
    }
  }
};
